<template>
  <div id="firebaseui-auth-container">
    <h1 style="text-align: center">You are Logging from {{country_name}}</h1>
    <h1 style="text-align: center" v-if="notFound">No country found, please select manually</h1>
  </div>
</template>
<script>
  import axios from 'axios';
  export default{
    name: 'Login',
    data () {
      return{
        country_code: '',
        country_name:'',
        notFound:false,
      }

    },
    mounted () {
      axios.get('http://ip-api.com/json/', {
            referrerPolicy: "unsafe_url" 
        })
        .then((response) => {
          console.log('User\'s Location Data is ', response);
          console.log('User\'s Country', response.data.countryCode);
          this.country_name = response.data.country;
          this.country_code = response.data.countryCode;
          localStorage.setItem('country-code',JSON.stringify(this.country_code))
          firebase.auth().settings.appVerificationDisabledForTesting = false;
          console.log(this.country_code)
          if (this.country_code != null){
            console.log(this.country_code)
            var uiConfig = {
              signInSuccessUrl: '/#/verifyotp',
              signInOptions: [
                {
                  //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                  //   firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                  //   firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                  //   firebase.auth.GithubAuthProvider.PROVIDER_ID,
                  //provider:firebase.auth.EmailAuthProvider.PROVIDER_ID,
                  provider:firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                  //  firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
                  defaultCountry: JSON.parse(localStorage.getItem('country-code')),
                }
              ],
              tosUrl: '/#/verifyotp',
              /*privacyPolicyUrl: function() {
                window.location.assign('<your-privacy-policy-url>');
              }*/
            };
            if(firebaseui.auth.AuthUI.getInstance()) {
              const ui = firebaseui.auth.AuthUI.getInstance();
              ui.start('#firebaseui-auth-container', uiConfig);
            }
            else {
              const ui = new firebaseui.auth.AuthUI(window.firebase.auth());
              ui.start('#firebaseui-auth-container', uiConfig);

            }
          }
          else {
            this.notFound = true;
            var uiConfig = {
              signInSuccessUrl: '/#/verifyotp',
              signInOptions: [
                {
                  //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                  //   firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                  //   firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                  //   firebase.auth.GithubAuthProvider.PROVIDER_ID,
                  //provider:firebase.auth.EmailAuthProvider.PROVIDER_ID,
                  provider:firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                  //  firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
                  defaultCountry: 'US',
                }
              ],
              tosUrl: '/#/verifyotp',
              /*privacyPolicyUrl: function() {
                window.location.assign('<your-privacy-policy-url>');
              }*/
            };
            if(firebaseui.auth.AuthUI.getInstance()) {
              const ui = firebaseui.auth.AuthUI.getInstance();
              ui.start('#firebaseui-auth-container', uiConfig);
            }
            else {
              const ui = new firebaseui.auth.AuthUI(window.firebase.auth());
              ui.start('#firebaseui-auth-container', uiConfig);

            }
          }
        })
        .catch(function (error) {
          console.log('Request failed.  Returned status of',
            error);
        });


    },

    // beforeMount(){
    //       localStorage.clear();
    // }
  }

</script>
